import React, { useState, useEffect } from "react";
import LogoSVS from "../../assets/images/logo_SVS_new.svg";
import LogoSVSEn from "../../assets/images/logo_SVS_new_EN.svg";
import LogoSVS_short from "../../assets/images/logo_SVS_new_SHORT.svg";
import LangSwitcher from "../../components/common/LangSwitcher";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

/** MUI */
import { makeStyles } from "@material-ui/core";
import { alpha, AppBar, IconButton, Link, List, ListItem, Popover, Toolbar, Box, CardMedia } from "@material-ui/core";
import { Menu } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    appBar: {
        backgroundColor: "#fff",
        maxHeight: theme.spacing(8),
        boxShadow: "none",
        borderBottom: `1px solid ${alpha("#000", 0.125)}`,
        padding: "0!important",
        zIndex: 9999,
    },
    toolbar: {
        display: "flex",
        justifyContent: "flex-start",
        [theme.breakpoints.up("xs")]: {
            justifyContent: "space-between",
        },
    },
    too: {
        paddingLeft: "24px",
        display: "flex",
        [theme.breakpoints.down("xs")]: {
            paddingLeft: 10,
        },
    },
    topMenuHolder: {
        display: "flex",
        flex: 1,
        justifyContent: "flex-end",
        alignItems: "center",
    },
    menuItems: {
        marginLeft: 20,
    },
    logo: {
        maxHeight: theme.spacing(6),
        verticalAlign: "middle",
        width: 270,
        [theme.breakpoints.down("xs")]: {
            margin: 0,
            width: 187,
            maxHeight: theme.spacing(5),
        },
    },
    logoEng: {
        width: 300,
    },
    menuPopoverPaper: {
        width: "calc(100% - 48px)",
        maxWidth: 400,
        left: "24px!important",
        top: "48px!important",
    },
}));

const Header = () => {
    const classes = useStyles();
    const { t, i18n } = useTranslation();

    /** States */
    const [isMobile, setIsMobile] = useState(window.innerWidth < 960);
    const [anchorEl, setAnchorEl] = useState(null);

    /** Effects */
    useEffect(() => {
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    /** Handeler */
    const handleResize = () => setIsMobile(window.innerWidth < 960);
    const handleOpenMobileMenu = (event) => setAnchorEl(event.currentTarget);
    const handleCloseMobileMenu = () => setAnchorEl(null);
    const open = Boolean(anchorEl);
    const id = open ? "mobile-menu-popover" : undefined;

    return (
        <div className={classes.root}>
            <AppBar position="fixed" color={"transparent"} className={classes.appBar}>
                <Toolbar className={classes.toolbar}>
                    {!!isMobile && (
                        <IconButton onClick={handleOpenMobileMenu} style={{ width: 50 }} aria-label={"menu"}>
                            <Menu />
                        </IconButton>
                    )}

                    <a href={"/"}>
                        {!!isMobile ? (
                            <CardMedia
                                component={"img"}
                                className={classes.logo}
                                image={LogoSVS_short}
                                alt={"svs logo"}
                            />
                        ) : (
                            <CardMedia
                                component={"img"}
                                className={clsx(classes.logo, i18n.language === "en" && classes.logoEng)}
                                image={i18n.language === "en" ? LogoSVSEn : LogoSVS}
                                alt={"svs logo"}
                            />
                        )}
                    </a>
                    {!!isMobile && <Box sx={{ width: 50, height: 50 }} />}
                    {!!isMobile || (
                        <div className={classes.topMenuHolder}>
                            <Link noWrap variant="body2" className={classes.menuItems} href={"/Info"}>
                                {t("Informacje o SVS")}
                            </Link>
                            <Link noWrap variant="body2" href={"/Kontakt"} className={classes.menuItems}>
                                {t("Kontakt")}
                            </Link>
                            <Link noWrap variant="body2" className={classes.too}>
                                <LangSwitcher />
                            </Link>
                        </div>
                    )}
                </Toolbar>
            </AppBar>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleCloseMobileMenu}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                classes={{ paper: classes.menuPopoverPaper }}
            >
                <List component="nav">
                    <ListItem button>
                        <Link noWrap variant="h6" className={classes.menuItems} href={"/Info"}>
                            {t("Informacje o SVS")}
                        </Link>
                    </ListItem>
                    <ListItem button>
                        <Link noWrap variant="h6" href={"/Kontakt"} className={classes.menuItems}>
                            {t("Kontakt")}
                        </Link>
                    </ListItem>
                    <ListItem button>
                        <Link noWrap variant="body2" className={classes.too}>
                            <LangSwitcher />
                        </Link>
                    </ListItem>
                </List>
            </Popover>
        </div>
    );
};

export default Header;
